import React, { FC } from 'react';
import DateTimeHover from '../date_time_component/DateTime';

const PastDue: FC<any> = ({
	dueDate,
	timeZoneId,
	showYear = true,
	showTime = true,
	className = '',
}) => {
	return (
		<span
			className={`${className} rowGrayChip`}
			style={{
				color: 'rgb(163, 40, 40)',
				backgroundColor: 'rgb(249, 230, 230)',
				whiteSpace: 'nowrap',
			}}
		>
			Past due{' '}
			<DateTimeHover
				timeZone={timeZoneId}
				timestamp={dueDate}
				showYear={showYear}
				showTime={showTime}
			/>
		</span>
	);
};

export default PastDue;
